import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask";
import { easepick, RangePlugin, LockPlugin, AmpPlugin }  from '@easepick/bundle';

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["period", "price", "duration"]

  connect() {
    this.picker = new easepick.create({
      element: this.periodTarget,
      css: [
        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css"
      ],
      zIndex: 10,
      lang: "de-DE",
      grid: 2,
      calendars: 2,
      format: "DD.MM.YYYY",
      autoApply: false,
      locale: {
        cancel: "Abbrechen",
        apply: "Auswählen"
      },
      AmpPlugin: {
        darkMode: false,
        resetButton: true
      },
      plugins: [RangePlugin, LockPlugin, AmpPlugin],
      RangePlugin: {
        delimiter: " - ",
        locale: { one: 'Tag', other: 'Tage' }
      },
      LockPlugin: {
        minDate: new Date()
      },
      setup(picker) {
        picker.on('select', (e) => {
          document.querySelector('.form-default').requestSubmit();
        })

        picker.on('clear', () => {
          document.querySelector('.form-default').requestSubmit();
          picker.hide();
        })
      }
    })


    this.durationTargets.forEach((durationField) => {
      Inputmask({
        alias: "integer",
        digits: 0,
        digitsOptional: false,
        showMaskOnFocus: false
      }).mask(durationField);
    });

    this.priceTargets.forEach((priceField) => {
      Inputmask({
        alias: "currency",
        suffix: " €",
        groupSeparator: ".",
        digits: 0,
        digitsOptional: false,
        showMaskOnFocus: false,
        numericInput: true
      }).mask(priceField);
    });
  }


  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const url = new URL(this.element.action)
      const params = new URLSearchParams(new FormData(this.element)).toString()
      window.history.replaceState({}, "", `${url.pathname}?${params}`)

      this.element.dataset.turboScroll = "false"

      this.element.requestSubmit()
    }, 200) // small debounce
  }
}
